import {
  IAppConfigurationProvider
} from '@dirootie-core/core-types';
import {
  AxiosLoggingInterceptor,
  AxiosErrorHandlerInterceptor,
  AxiosBearerTokenInterceptor,
  AxiosHttpClientOptions,
  AxiosHttpClient,
} from '@dirootie-http/http-axios';
import { ILogger } from '@dirootie-logging/logging-types';
import { IViewNavigator } from '@dirootie-web/web-apps-types';
import { IUserNotificationService } from '@dirootie-web/web-components-types';
import { configSettings } from '../../configuration/ConfigurationSettings';
//import { WithLogging } from './Logging.decorator';
import { IAppModule, IServiceProvider } from './modules.types';
import { ErrorHandlersFactory } from '../temporary/error-handler.factory';

export class HttpModule implements IAppModule {
  name = 'http';


  configureServices(
    serviceProvider: IServiceProvider,
    configurationProvider: IAppConfigurationProvider
  ): void {
    const logger = serviceProvider.resolve<ILogger>('logger')!;
    const navigator = serviceProvider.resolve<IViewNavigator>('navigator')!;
    const userService = serviceProvider.resolve<IUserNotificationService>(
      'user-notification-service'
    )!;

    const errorHandlerFactory = new ErrorHandlersFactory(logger, userService, navigator);
    const loggingInterceptor = new AxiosLoggingInterceptor({ active: true, logger });
    const errorInterceptor = new AxiosErrorHandlerInterceptor(logger, { handlers: errorHandlerFactory.Create() });

    const msalTokenProvider = serviceProvider.resolve<() => Promise<string>>(
      'msal-token-provider'
    );
    const bearerTokenInterceptor = new AxiosBearerTokenInterceptor(logger,{
        tokenProvider: async () => {
          // return Promise.resolve();
          try {
            return await msalTokenProvider();
          } catch (x) {
            console.log('MsalTokenProvider:error:', x);
            return await Promise.reject();
          }
        },
      })


    const options = {
      interceptors: [
        loggingInterceptor,
        bearerTokenInterceptor,
        errorInterceptor,
      ],
      logger,
      baseUrl: configSettings.api.baseUrl,
    }
    // const withLogging =
    //   serviceProvider.resolve<WithLogging<AxiosHttpClient>>('with-logging');
    //const axiosInstance = withLogging(new AxiosHttpClient(options));
    const axiosInstance = new AxiosHttpClient(options);
    serviceProvider.register('http-client',axiosInstance);
  }
}
